export default __webpack_public_path__ + "static/coding_bootcamp-3d2ffc3614a7833903392a31cd603674.jpeg";